import i18n from '@/i18n';
import { brands } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const Brands = () => import('./views/Index.vue');

export default [
  {
    path: 'brands',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.Brands`,
        component: Brands,
        meta: { title: i18n.global.t('brands.brands'), permission: { module: brands.module, key: brands.showAll } },
      },
    ],
  },
];
